export function canAccess(permissions, menuKey, action = 'view') {
  if (!permissions || !menuKey) return false;
  const perm = permissions[menuKey];
  if (!perm) return false;
  if (action === 'view') return !!perm.view;
  if (action === 'create') return !!perm.create;
  if (action === 'edit') return !!perm.edit;
  if (action === 'delete') return !!perm.delete;
  return false;
}

export function filterMenuByPermissions(menuTree, permissions) {
  if (!Array.isArray(menuTree)) return [];
  return menuTree
    .map((item) => {
      const key = item.menu_key;
      const children = filterMenuByPermissions(item.sub || [], permissions);
      const selfView = key ? canAccess(permissions, key, 'view') : false;

      if (!item.path && children.length > 0) {
        return { ...item, sub: children };
      }
      if (item.path && selfView) {
        return { ...item, sub: children };
      }
      if (!item.path && selfView && children.length === 0) {
        return { ...item, sub: [] };
      }
      return null;
    })
    .filter(Boolean);
}
